/*
 * @Author: Cphayim
 * @Date: 2019-05-13 00:52:43
 * @LastEditTime: 2022-02-10 23:15:58
 * @Description: 入口文件
 */

import Vue from 'vue'

import config from '@/config'

// 导入所有全局样式文件（保证所有全局样式在组件样式之前，需要在 App.vue 之前导入）
import 'jquery'
import '@/render/assets/scss'

import { registerPlugins } from '@/render/plugins'
import { registerDirectives } from '@/render/directives'
import { registerFilters } from '@/render/filters'
import { registerMixins } from '@/render/mixins'
import { registerEventBus } from '@/render/utils/event-bus'

import router from '@/render/router'
import store from '@/render/store'
import App from '@/render/App.vue'

/* eslint-disable */
window.$ = $
function decorateDate () {
  const OldDate = Date
  // 重写arguments[0]
  Date = function () {
    if (arguments.length > 0 && typeof (arguments[0]) === 'string' && arguments[0].includes('-')) {
      const p = arguments[0].replace(/-/g, '/')
      arguments[0] = p
    }
    return new OldDate(...arguments)
  }
  // 继承原型函数
  Date.prototype = OldDate.prototype
  // 继承静态函数，过滤已有的静态函数和参数，取数组差集
  const oldDateStaticParam = Object.getOwnPropertyNames(OldDate)
  const dateStaticParam = Object.getOwnPropertyNames(Date)
  const diffParam = []
  for (let i = 0; i < oldDateStaticParam.length; i++) {
    let find = false
    for (let j = 0; j < dateStaticParam.length; j++) {
      if (oldDateStaticParam[i] === dateStaticParam[j]) {
        find = true
        break
      }
    }
    if (!find) {
      diffParam.push(oldDateStaticParam[i])
    }
  }
  for (let i = 0; i < diffParam.length; i++) {
    Date[diffParam[i]] = OldDate[diffParam[i]]
  }
}
// IOS环境
// if (navigator.userAgent.includes('iPhone') || navigator.userAgent.includes('iPad') || navigator.userAgent.includes('Safari')) {
  decorateDate()
// }
// 是否启用Mock数据
if (config.ENVS.IS_DEV && config.SERVICES.MOCK_ENABLE) {
  require('../mock')
}

Vue.config.productionTip = false

// 注册所有插件
registerPlugins(Vue)
// 注册全局指令
registerDirectives(Vue)
// 注册全局过滤器
registerFilters(Vue)
// 全局混入
registerMixins(Vue)
// 注册 EventBus
registerEventBus()

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
